import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const SinPartyContext = createContext();

// ─── Map SinParty tags/categories → our URL slugs ────────────────────────────
export const CATEGORY_MAP = {
  "milf": "milf-cam-girls",
  "teen": "teen-cam-girls",
  "asian": "asian-cam-girls",
  "ebony": "ebony-cam-girls",
  "latina": "latina-cam-girls",
  "blonde": "blonde-cam-girls",
  "brunette": "brunette-cam-girls",
  "mature": "mature-cam-girls",
  "amateur": "amateur-cam-girls",
  "big-tits": "big-tits-cam-girls",
  "busty": "big-tits-cam-girls",
  "big-ass": "big-ass-cam-girls",
  "natural-tits": "natural-tits-cam-girls",
  "toys": "toys-cam-girls",
  "squirt": "squirt-cam-girls",
  "anal": "anal-cam-girls",
  "college-age": "college-cam-girls",
  "redhead": "redhead-cam-girls",
  "tattoos": "tattoo-cam-girls",
  "feet": "feet-cam-girls",
  "bdsm": "bdsm-cam-girls",
  "dominant": "dominant-cam-girls",
  "submissive": "submissive-cam-girls",
  "couples": "couples-cam",
  "masturbation": "masturbation-cams",
  "striptease": "striptease-cams",
  "lovense": "lovense-cams",
  "oil": "oil-show-cams",
  "dirty-talk": "dirty-talk-cams",
  "blowjob": "blowjob-cams",
  "deepthroat": "deepthroat-cams",
  "cowgirl": "cowgirl-cams",
  "topless": "topless-cams",
  "twerking": "twerk-cams",
  "ahegao": "ahegao-cams",
  "spanish": "spanish-cam-girls",
  "russian": "russian-cam-girls",
  "indian": "indian-cam-girls",
  "petite": "petite-cam-girls",
  "slim": "petite-cam-girls",
};

export const filterSinParty = (performers, filters = {}) => {
  if (!Array.isArray(performers)) return [];

  const safeFilters = {
    ethnicity: [],
    age: [],
    fetishes: [],
    build: [],
    searchTerm: '',
    ...filters
  };

  return performers.filter(performer => {
    const hasActiveFilters = Object.values(safeFilters).some(arr =>
      Array.isArray(arr) ? arr.length > 0 : false
    );
    const hasSearchTerm = safeFilters.searchTerm?.trim().length > 0;

    if (!hasActiveFilters && !hasSearchTerm) return true;

    if (hasSearchTerm) {
      const terms = safeFilters.searchTerm.toLowerCase().split(/[\s,]+/).filter(Boolean);
      const SYNONYMS = {
        'latin': 'hispanic', 'latina': 'hispanic', 'latino': 'hispanic',
        'black': 'ebony', 'african': 'ebony',
        'japanese': 'asian', 'korean': 'asian', 'chinese': 'asian',
        'white': 'caucasian', 'arab': 'middleeastern', 'arabic': 'middleeastern',
        'blonde': 'blond', 'brunette': 'brown', 'redhead': 'red', 'ginger': 'red',
        'slim': 'slim', 'skinny': 'slim', 'thick': 'curvy', 'fit': 'athletic',
        'teen': 'teen', 'young': 'teen', 'milf': 'milf', 'mature': 'mature',
        'squirt': 'squirt', 'dom': 'dominat', 'feet': 'feet', 'femdom': 'femdom',
        'lesbian': 'lesbian', 'bdsm': 'bdsm', 'anal': 'anal',
      };
      const name = (performer.displayName || '').toLowerCase();
      const eth  = (performer.ethnicity || '').toLowerCase();
      const age  = parseInt(performer.age) || 0;
      const tags = (performer.fetishes || []).map(w => w.toLowerCase());
      const allText = [name, eth, ...tags].join(' ');

      const score = terms.reduce((s, t) => {
        const syn = SYNONYMS[t] || t;
        if (name.includes(t)) return s + 10;
        if (eth === t || eth === syn || eth.includes(syn)) return s + 8;
        if ((t === 'teen' || t === 'young') && age >= 18 && age <= 22) return s + 7;
        if ((t === 'milf' || t === 'mature') && age >= 30) return s + 7;
        if (tags.some(tg => tg.includes(syn) || tg.includes(t))) return s + 7;
        if (allText.includes(t)) return s + 3;
        return s;
      }, 0);

      if (score === 0) return false;
    }

    const checks = {
      ethnicity: !safeFilters.ethnicity?.length ||
        safeFilters.ethnicity.some(ethnicity =>
          performer.ethnicity?.toLowerCase() === ethnicity.toLowerCase()
        ),
      age: !safeFilters.age?.length ||
        safeFilters.age.some(ageRange => {
          const age = parseInt(performer.age);
          if (!age) return false;
          switch (ageRange) {
            case "Teen 18+": return age >= 18 && age <= 19;
            case "20s": return age >= 20 && age <= 29;
            case "30s": return age >= 30 && age <= 39;
            case "40s": return age >= 40 && age <= 49;
            case "Mature 50+": return age >= 50;
            default: return false;
          }
        }),
      fetishes: !safeFilters.fetishes?.length ||
        safeFilters.fetishes.some(fetish =>
          performer.fetishes?.some(f =>
            f?.toLowerCase() === fetish.toLowerCase()
          )
        ),
    };

    return Object.values(checks).every(result => result);
  });
};

const SINPARTY_API = "https://api.sinparty.com/v2/web/live-cams/web-rtc";
const SINPARTY_KEY = "XOmh0dHBzOi8vaW5zdGFjYW1naXJscy5jb20=";
const SINPARTY_TRACKING = "?linkId=lp_638879&sourceId=xentraffic&tenantId=sinaffiliates";

export const SinPartyProvider = ({ children }) => {
  const [performers, setPerformers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPerformers = async () => {
      try {
        const response = await axios.get(SINPARTY_API, {
          params: {
            per_page: 100,
            page: 1,
            per_page: 100,
          },
          headers: {
            'X-Affiliate-Key': SINPARTY_KEY,
          },
        });

        const models = response.data?.data?.items || response.data?.data?.models || response.data?.data || response.data?.models || response.data || [];
        const modelsArray = Array.isArray(models) ? models : [];

        if (modelsArray.length === 0) {
          setPerformers([]);
          setLoading(false);
          return;
        }

        const performersData = modelsArray
          .filter(m => m.live_status === 'live' || m.live_status === 'online' || m.live_status)
          .map((model) => {
            const thumbnail = model.thumbnail_url
              || (model.poster_set_template ? model.poster_set_template.replace('{size}', '480') : '')
              || '';

            const categories = Array.isArray(model.categories) ? model.categories : [];
            const mapped = categories
              .map(c => CATEGORY_MAP[c.toLowerCase()])
              .filter(Boolean);

            const hash = model.creator_user_hash || model.model_id || '';
            const slug = (model.title || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
            const fallbackPath = hash
              ? `/en/models/${slug || hash}/${hash}`
              : '/';
            return {
              uniqueModelId: `sp_${model.model_id || model.creator_user_hash}`,
              performerId: model.creator_user_hash || model.model_id,
              displayName: model.title || 'SinParty Model',
              profilePictureUrl: thumbnail,
              profilePictureFullUrl: thumbnail,
              chatRoomUrl: model.live_url
                ? `https://sinparty.com${model.live_url}${SINPARTY_TRACKING}`
                : `https://sinparty.com${fallbackPath}${SINPARTY_TRACKING}`,
              ethnicity: model.country || 'N/A',
              age: model.age ? String(model.age) : 'N/A',
              fetishes: categories,
              details: {
                willingnesses: categories,
              },
              viewers: model.viewers || 0,
              source: 'sinparty',
              _isSinParty: true,
              mappedCategories: mapped,
              isNew: !!model.is_new,
              country: model.country || '',
            };
          });

        setPerformers(performersData);
        setLoading(false);

        if (performersData.length > 0) {
          const API_URL = process.env.REACT_APP_API_URL || "https://api.instacamgirls.com";
          const batch = performersData.slice(0, 100).map(p => ({
            name: p.displayName,
            displayName: p.displayName,
            network: "sinparty",
            profilePictureUrl: p.profilePictureUrl,
            chatRoomUrl: p.chatRoomUrl,
            fetishes: p.fetishes || [],
            ethnicity: p.country || "",
            age: parseInt(p.age) || null,
          }));
          axios.post(`${API_URL}/api/performers-directory/upsert`, { performers: batch }).catch(() => {});
        }
      } catch (error) {
        console.error("Error fetching SinParty performers:", error);
        setPerformers([]);
        setLoading(false);
      }
    };

    fetchPerformers();
  }, []);

  return (
    <SinPartyContext.Provider value={{ performers, loading }}>
      {children}
    </SinPartyContext.Provider>
  );
};
